import React, { memo } from 'react'
import { Box } from 'transfix-ui/core'
import { EQUIPMENT_FOR_LANES } from 'constants/equipment'

interface IShipper {
  id: number
  name: string
}

interface IRoutingGuidesSpecificLaneProps {
  specificLane: {
    pickupCity?: string
    pickupStateCode?: string
    pickupRadiusMiles: number | null
    deliveryCity?: string
    deliveryStateCode?: string
    deliveryRadiusMiles: number | null
    equipmentId: string | number
    isOnlyDropTrailer: boolean | null
    shipper?: IShipper
  }
}
interface ILocationProps {
  city: string
  miles?: string | number | null
}

const Location = memo<ILocationProps>(({ city, miles }) => (
  <span>
    {city}&nbsp;
    {Boolean(miles) && <span className='text-secondary'>{miles}</span>}
  </span>
))

export const SpecificLane = memo<IRoutingGuidesSpecificLaneProps>(({ specificLane }) => {
  const {
    deliveryCity,
    deliveryRadiusMiles,
    deliveryStateCode,
    equipmentId,
    isOnlyDropTrailer,
    pickupCity,
    pickupRadiusMiles,
    pickupStateCode,
    shipper,
  } = specificLane || {}
  const equipmentName = EQUIPMENT_FOR_LANES.find(eq => eq.id === parseInt(String(equipmentId), 10))
    ?.name

  return (
    <Box>
      <Box>
        <Location
          city={`${pickupCity}, ${pickupStateCode}`}
          miles={pickupRadiusMiles && `+${pickupRadiusMiles}`}
        />
        &nbsp;&rarr;&nbsp;
        <Location
          city={`${deliveryCity}, ${deliveryStateCode}`}
          miles={deliveryRadiusMiles && `+${deliveryRadiusMiles}`}
        />
      </Box>
      <Box>
        <span className='text-secondary'>
          {shipper?.name || 'Any Shipper'}&nbsp;&middot;&nbsp;
          {equipmentName}&nbsp;&middot;&nbsp;
          {isOnlyDropTrailer ? 'Drop' : 'Live'}
        </span>
      </Box>
    </Box>
  )
})
